export const TIMER_REGISTRATION = 'timer_registration'
export const TIMER_REGISTRATION_TIME = 60000

export const LeadRegistrationStepsEnum = {
  FORM_STEP: 'form',
  CONFIRM_CODE_STEP: 'confirmCode',
  ERROR_STEP: 'error',
} as const

export const firstStepConfig = LeadRegistrationStepsEnum.FORM_STEP

export const stepsConfigs = [
  LeadRegistrationStepsEnum.FORM_STEP,
  LeadRegistrationStepsEnum.CONFIRM_CODE_STEP,
  LeadRegistrationStepsEnum.ERROR_STEP,
]
